import { render } from "./ConfigurationHierarchy.vue?vue&type=template&id=5c3458d8"
import script from "./ConfigurationHierarchy.vue?vue&type=script&lang=js"
export * from "./ConfigurationHierarchy.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__